import axios from 'axios'
import { showToast, showDialog } from 'vant'
import router from '@/router'
import store from '@/store'
import { API_CONFIG } from '@/config/config'

// 创建axios实例
const request = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: 60000,
  withCredentials: false, // 跨域请求时不发送cookies
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 添加微信token认证信息
    const token = localStorage.getItem('wechat_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    const { data } = response
    
    // 检查业务状态码，处理401和402未登录情况
    if (data && (data.code === 401 || data.code === 402)) {
      // 调用store的logout方法统一处理退出登录
      store.dispatch('logout')
      
      // 清除微信相关的本地存储
      localStorage.removeItem('wechat_token')
      localStorage.removeItem('wechat_user_info')
      
      // 显示登录失效提示
      showToast({
        message: data.msg || '登录已失效，请重新登录',
        type: 'fail',
        duration: 2000 // 2 seconds duration
      })
      
      // 跳转到我的页面
      router.push({
        name: 'Profile'
      })
      
      return Promise.reject(new Error(data.msg || '登录已失效'))
    }
    
    // 处理业务状态码为400的情况（请求参数错误等）
    if (data && data.code === 400) {
      // 显示服务器返回的错误信息
      showDialog({
        title: '请求错误',
        message: data.msg || '请求参数错误',
        confirmButtonText: '知道了'
      })
      
      return Promise.reject(new Error(data.msg || '请求参数错误'))
    }
    
    // 直接返回完整的响应数据，让组件自己处理
    return data
  },
  error => {
    // 超时错误
    if (error && error.code === 'ECONNABORTED') {
      showToast({
        message: '请求超时，请稍后重试',
        type: 'fail',
        duration: 2000
      })
      return Promise.reject(error)
    }

    // 处理HTTP状态码错误
    if (error.response) {
      const { status, data } = error.response
      
      if (status === 401 || status === 402) {
        // 调用store的logout方法统一处理退出登录
        store.dispatch('logout')
        
        // 清除微信相关的本地存储
        localStorage.removeItem('wechat_token')
        localStorage.removeItem('wechat_user_info')
        
        // 显示登录失效提示
        showToast({
          message: status === 402 ? '登录已失效，请重新登录' : '您还未登录，请登录',
          type: 'fail',
          duration: 2000 // 2 seconds duration
        })
        
        // 跳转到我的页面
        router.push({
          name: 'Profile'
        })
      } else {
        // 其他HTTP错误
        const errorMessage = data?.msg || `请求失败 (${status})`
        showDialog({
          title: '请求错误',
          message: errorMessage,
          confirmButtonText: '知道了'
        })
        
        return Promise.reject(new Error(errorMessage))
      }
    } else {
      // 网络错误或其他错误
      const errorMessage = error && error.message ? error.message : '网络连接失败，请检查网络设置'
      showDialog({
        title: '网络错误',
        message: errorMessage,
        confirmButtonText: '知道了'
      })
      
      return Promise.reject(new Error(errorMessage))
    }
    
    return Promise.reject(error)
  }
)

export default request
